<div class="folder-content-wrapper">
  @if (isMobileScreen) {
    <app-folder-content-mobile
      [folderContent]="data"
    ></app-folder-content-mobile>
  } @else {
    <app-folder-content-desktop
      [folderContent]="data"
    ></app-folder-content-desktop>
  }
</div>
